import { render } from "./OrderSummaryDocuments.vue?vue&type=template&id=8677ce0e&scoped=true&ts=true"
import script from "./OrderSummaryDocuments.vue?vue&type=script&lang=ts"
export * from "./OrderSummaryDocuments.vue?vue&type=script&lang=ts"

import "./OrderSummaryDocuments.vue?vue&type=style&index=0&id=8677ce0e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8677ce0e"]])

export default __exports__
import QSpinnerFacebook from 'quasar/src/components/spinner/QSpinnerFacebook.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerFacebook,QBtn});
